// © Microsoft Corporation. All rights reserved.

import { TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { PublisherCarouselStrings } from "./PublisherCarousel.strings";

export interface PublisherInfo {
    id: string;
    name: string;
    logoUrl: string;
    profileId: string;
    isSubscribed?: boolean;
}

export interface PublisherCardData {
    clickUrl: string;
    contentIndicator?: string; // icon indicating content type
    id: string;
    imageInfo: {
        altText: string;
        sourceImageUrl: string;
    };
    isPremium: boolean;
    localizedStrings: PublisherCarouselStrings;
    publisher: PublisherInfo;
    telemetry: {item: TelemetryObjectBase, destination: TelemetryObjectBase}
    title: string;
}

export interface PublisherCarouselData {
    cards: PublisherCardData[];
    publishers: PublisherInfo[];
    seeAllLinkUrl: string;
}

export interface PublisherContentData {
    id: string;
    type: string;
    title: string;
    subTitle?: string;
    abstract?: string;
    url: string;
    locale: string;
    images: {
        width: number;
        height: number;
        quality?: number;
        url: string;
        attribution?: string;
        title?: string;
        focalRegion?: any;
        source?: string
    }[];
    provider: PublisherInfo;
    category: string;
    vertical?: string;
    galleryItemCount?: number;
    publishedDateTime?: string;
    dataUrl?: string;
    subscriptionProductType?: string
}

export enum PublisherCarouselTheme {
    default = "default",
    articlePage = "articlePage"
}